import LPResultsPage from "./LPResultsPage";

export default function LPAccountManagersResultsPage() {
  return <LPResultsPage lpSlug="account-managers" lpName="Account Managers" />;
}
